import z from "zod";

const audioProcessingErrorTypeValues = [
  "DURATION_PARSE_FAILED",
  "FFPROBE_FAILED",
  "FFMPEG_FAILED",
  "FFMPEG_SPAWN_ERROR",
] as const;

const audioProcessingErrorTypeSchema = z.enum(audioProcessingErrorTypeValues);
const AudioProcessingErrorType = audioProcessingErrorTypeSchema.enum;
type AudioProcessingErrorType = z.infer<typeof audioProcessingErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type AudioProcessingErrors =
  | {
      errorType: typeof AudioProcessingErrorType.DURATION_PARSE_FAILED;
      data: {
        output: string;
        filePath?: string;
      };
    }
  | {
      errorType: typeof AudioProcessingErrorType.FFPROBE_FAILED;
      data: {
        exitCode: number | null;
        filePath?: string;
      };
    }
  | {
      errorType: typeof AudioProcessingErrorType.FFMPEG_FAILED;
      data: {
        exitCode: number | null;
        stderr: string;
        args?: string[];
      };
    }
  | {
      errorType: typeof AudioProcessingErrorType.FFMPEG_SPAWN_ERROR;
      data: {
        errorMessage: string;
        args?: string[];
      };
    };

export const audioProcessingErrorDetails: Record<AudioProcessingErrorType, ErrorDetails> = {
  [AudioProcessingErrorType.DURATION_PARSE_FAILED]: {
    sentryDescription: "Failed to parse audio duration from ffprobe output",
  },
  [AudioProcessingErrorType.FFPROBE_FAILED]: {
    sentryDescription: "FFprobe command failed",
  },
  [AudioProcessingErrorType.FFMPEG_FAILED]: {
    sentryDescription: "FFmpeg command failed",
  },
  [AudioProcessingErrorType.FFMPEG_SPAWN_ERROR]: {
    sentryDescription: "Failed to spawn FFmpeg process",
  },
};
